import AdditivesSelect from './AdditivesSelect';
import AllergensSelect from './AllergensSelect';
import NutritionInfoFields from './NutritionInfoFields';

export default {
  AdditivesSelect,
  AllergensSelect,
  NutritionInfoFields,
};
